<template>
  <div>
    <div class="elevation-0 pa-4 ma-0" style="background:white; border-radius:3px;">
      <v-list-tile-title class="subheading">
        Subject: {{ eventDateObj.params.subject }}
      </v-list-tile-title>
      <div class="elevation-0 pa-4 ma-0" style="background:white; border-radius:3px;">
        <p v-html="eventDateObj.params.body"></p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Conversations",
  data: () => ({
    actionText: {
      remove_participants: "Removed",
      add_participants: "Added"
    },
    emailRecipients: []
  }),
  props: ["eventDateObj"],
  components: {
  },
  methods: {
    emailRecipientUsed: function(email) {
      if (this.emailRecipients.includes(email)) return true
      this.emailRecipients.push(email)
      return false
    }
  }
}
</script>
<style>
.timeline-entry-iframe {
  width: 100%;
  border: none;
  outline: none;
}
</style>
